import cashAccountsApi from '@/api/cashAccounts';
import currenciesApi from '@/api/currencies';

const actions = {
  async listCurrencies(_ctx, onlyActive) {
    const { data } = await currenciesApi.list(onlyActive);
    return data || [];
  },
  async createCurrency(_ctx, payload) {
    const { data } = await currenciesApi.create(payload);
    return data;
  },
  async updateCurrency(_ctx, { id, payload }) {
    const { data } = await currenciesApi.update(id, payload);
    return data;
  },
  async deleteCurrency(_ctx, id) {
    await currenciesApi.remove(id);
  },
  async listCashAccounts(_ctx, payload) {
    const p = payload || {};
    const status = typeof p === 'string' ? p : p.status;
    const companyId = typeof p === 'object' ? p.companyId : null;
    const { data } = await cashAccountsApi.list(companyId, status);
    return data || [];
  },
  async createCashAccount(_ctx, payload) {
    const { data } = await cashAccountsApi.create(payload);
    return data;
  },
  async updateCashAccount(_ctx, { id, payload }) {
    const { data } = await cashAccountsApi.update(id, payload);
    return data;
  },
  async deleteCashAccount(_ctx, id) {
    await cashAccountsApi.remove(id);
  },
  async cashAddIncome(_ctx, payload) {
    const { data } = await cashAccountsApi.addIncome(payload);
    return data;
  },
  async cashExternalPayment(_ctx, payload) {
    const { data } = await cashAccountsApi.externalPayment(payload);
    return data;
  },
  async cashTransfer(_ctx, payload) {
    const { data } = await cashAccountsApi.transfer(payload);
    return data;
  },
  async cashAdjust(_ctx, payload) {
    const { data } = await cashAccountsApi.adjust(payload);
    return data;
  },
  async cashHistory(_ctx, payload) {
    const p = payload || {};
    const { data } = await cashAccountsApi.getHistory(p.subType, p.date);
    return data || [];
  },
  async myCashAccounts() {
    const { data } = await cashAccountsApi.getMyAccounts();
    return data || { companyId: null, companyName: null, accounts: [] };
  },
  async myCashHistory(_ctx, payload) {
    const p = payload || {};
    const { data } = await cashAccountsApi.getMyHistory(p.subType, p.date);
    return data || [];
  },
  async cashSnapshots(_ctx, payload) {
    const p = payload || {};
    const startDate = typeof p === 'string' ? p : p.startDate;
    const endDate = typeof p === 'string' ? p : p.endDate;
    const { data } = await cashAccountsApi.getSnapshots(startDate, endDate);
    return data || [];
  },
};

export default { namespaced: true, state: {}, getters: {}, actions, mutations: {} };
